import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyA7fIhqnXlYVEaT4xppPyjbHkallb4ybYI',
  authDomain: 'watsdat-21fb5.firebaseapp.com',
  projectId: 'watsdat-21fb5',
  storageBucket: 'watsdat-21fb5.appspot.com',
  messagingSenderId: '7722576228',
  appId: '1:7722576228:web:b7e46d5d335785c6b6f271',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
